/**
 * Renders a milsymbol SVG at any size.
 * Works offline — milsymbol generates SVG client-side from the SIDC string.
 */

import { getSymbolSvg, isValidSidc } from '@shared/components/Symbol/symbol-cache';
import { memo } from 'react';

interface SymbolPreviewProps {
  sidc: string;
  size?: number;
  className?: string;
}

export const SymbolPreview = memo(function SymbolPreview({
  sidc,
  size = 64,
  className = '',
}: SymbolPreviewProps) {
  if (!sidc || !isValidSidc(sidc)) {
    return (
      <div
        className={`flex items-center justify-center text-base-content/30 ${className}`}
        style={{ width: size, height: size }}
      >
        <span className="text-2xl">?</span>
      </div>
    );
  }

  const svg = getSymbolSvg(sidc, size);

  return (
    <div
      className={`rounded bg-white p-1 ${className}`}
      style={{
        width: size + 8,
        height: size + 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: milsymbol generates trusted SVG from code
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
});
